import React, { useState } from 'react';

const TableOfContents = ({ headings = [] }) => {
  const [showAll, setShowAll] = useState(false);

  if (!headings || headings.length === 0) return null;

  const getFixedHeaderHeight = () => {
    const selectors = [
      'header',
      'nav',
      '.site-header',
      '.navbar',
      '.fixed-header',
      '.sticky-header',
      '[class*="header"]',
      '[class*="navbar"]',
      '[class*="nav-bar"]',
    ];

    let maxHeight = 0;

    selectors.forEach((selector) => {
      const els = document.querySelectorAll(selector);

      els.forEach((el) => {
        const style = window.getComputedStyle(el);

        if (style.position === 'fixed' || style.position === 'sticky') {
          const rect = el.getBoundingClientRect();

          if (rect.top >= 0 && rect.height > 0) {
            maxHeight = Math.max(maxHeight, rect.bottom);
          }
        }
      });
    });

    return maxHeight;
  };

  const handleClick = (e, id) => {
    e.preventDefault();

    const el = document.getElementById(id);
    if (!el) return;

    const headerHeight = getFixedHeaderHeight();
    const additionalOffset = 16;
    const elementTop = window.scrollY + el.getBoundingClientRect().top;
    const top = elementTop - headerHeight - additionalOffset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };

  // Show first 10 or all headings
  const visibleHeadings = showAll ? headings : headings.slice(0, 10);

  return (
    <aside
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '20px 24px',
        backgroundColor: '#f9fafb',
        marginBottom: '24px',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '16px',
        }}
      >
        {/* Hamburger icon */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              display: 'block',
              width: '18px',
              height: '2px',
              backgroundColor: '#374151',
              borderRadius: '1px',
            }}
          />
          <span
            style={{
              display: 'block',
              width: '18px',
              height: '2px',
              backgroundColor: '#374151',
              borderRadius: '1px',
            }}
          />
          <span
            style={{
              display: 'block',
              width: '18px',
              height: '2px',
              backgroundColor: '#374151',
              borderRadius: '1px',
            }}
          />
        </div>

        <h4
          style={{
            margin: 0,
            fontSize: '16px',
            fontWeight: '700',
            color: '#111827',
            letterSpacing: '0.01em',
          }}
        >
          Table of Contents
        </h4>
      </div>

      {/* List */}
      <ul
        style={{
          margin: '0 0 12px 0',
          padding: 0,
          listStyle: 'none',
        }}
      >
        {visibleHeadings.map((h, idx) => (
          <li
            key={idx}
            style={{
              marginBottom: '8px',
              display: 'flex',
              gap: '6px',
            }}
          >
            <span
              style={{
                fontSize: '14px',
                fontWeight: '700',
                color: '#111827',
                flexShrink: 0,
              }}
            >
              {idx + 1}.
            </span>

            <a
              href={'#' + h.id}
              onClick={(e) => handleClick(e, h.id)}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
              }}
              style={{
                fontSize: '14px',
                fontWeight: '700',
                color: '#111827',
                textDecoration: 'none',
              }}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>

      {/* Read more / less */}
      {headings.length > 10 && (
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            fontSize: '13px',
            color: '#2563eb',
            fontWeight: '500',
          }}
        >
          {showAll ? 'Read less' : `Read more (${headings.length - 10} more)`}
        </button>
      )}
    </aside>
  );
};

export default TableOfContents;